import React from "react";
import { Card, CardBody } from "reactstrap";
import HelpSearch from "../HelpSearch";
import HelpActions from "../HelpActions";
import HelpCards from "../HelpCards";
import ConfirmationModal from "../../../../globals/core/ConfirmationModal/ConfirmationModal";
import { HelpItem } from "../../types/HelpTypes";
import { HelpCardItem } from "../HelpCards";

export interface HelpListProps {
  items: HelpItem[];
  search: string;
  typeFilter: "all" | "PDF" | "Video"; // Updated to match Salesforce values
  loading: boolean;
  onSearchChange: (search: string) => void;
  onTypeFilterChange: (type: "all" | "PDF" | "Video") => void; // Updated to match Salesforce values
  onCreateNew: () => void;
  onManage: (id: string) => void; // Changed to string
  onDelete: (id: string) => void; // Changed to string
  onReorder: (reorderedItems: HelpCardItem[]) => void;
  confirmOpen: boolean;
  onCloseConfirm: () => void;
  onConfirmDelete: () => void;
}

export const HelpList: React.FC<HelpListProps> = ({
  items,
  search,
  typeFilter,
  loading,
  onSearchChange,
  onTypeFilterChange,
  onCreateNew,
  onManage,
  onDelete,
  onReorder,
  confirmOpen,
  onCloseConfirm,
  onConfirmDelete,
}) => {
  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <CardBody>
              <HelpActions
                onCreateNew={onCreateNew}
              />
              <HelpSearch
                search={search}
                typeFilter={typeFilter}
                onSearchChange={onSearchChange}
                onTypeFilterChange={onTypeFilterChange}
              />
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading help items...</p>
                </div>
              ) : (
                <HelpCards
                  items={items as HelpCardItem[]}
                  onManage={onManage}
                  onDelete={onDelete}
                  onReorder={onReorder}
                />
              )}
              <ConfirmationModal
                open={confirmOpen}
                title="Delete Help Item"
                message="Are you sure you want to delete this help item?"
                onClose={onCloseConfirm}
                buttons={[
                  { label: "Cancel", style: "info", loading: false, onClick: onCloseConfirm },
                  { label: "Delete", style: "error", loading: false, onClick: onConfirmDelete },
                ]}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default HelpList;